var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJst(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.48 1c.266 7.789 6.658 14.02 14.513 14.02 7.854 0 14.246-6.231 14.512-14.02h-4.98c-.261 5.04-4.432 9.045-9.532 9.045-5.1 0-9.272-4.005-9.533-9.045H1.48zm12.642 6.217a3.367 3.367 0 1 0 3.74-5.599 3.367 3.367 0 0 0-3.74 5.599zm0 23.216a3.367 3.367 0 1 0 3.741-5.6 3.367 3.367 0 0 0-3.74 5.6zM2.224 22.005v-4.673H29.76v4.673H2.225z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJst);
export default __webpack_public_path__ + "static/media/JST.aecc50d1b8dd16c9dee4d8da0b140be1.svg";
export { ForwardRef as ReactComponent };